import React from 'react'
import BeatLoader from "react-spinners/BeatLoader";

const Loader = () => <BeatLoader color='#6b8f00' size={15} margin={2} />

export default Loader